// This is the root reducer of the feature. It is used for:
//   1. Load reducers from each action in the feature and process them one by one.
//      Note that this part of code is mainly maintained by Rekit, you usually don't need to edit them.
//   2. Write cross-topic reducers. If a reducer is not bound to some specific action.
//      Then it could be written here.
// Learn more from the introduction of this approach:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da.

import initialState from './initialState';
import { reducer as setSelectedServiceReducer } from './setSelectedService';
import { reducer as getServiceListReducer } from './getServiceList';
import { reducer as getSelectedServiceReducer } from './getSelectedService';
import { reducer as setServiceOnwardReducer } from './setServiceOnward';
import { reducer as setServiceReturnReducer } from './setServiceReturn';
import { reducer as setServiceListReducer } from './setServiceList';
import { reducer as selectSeatOnwardReducer } from './selectSeatOnward';
import { reducer as selectSeatReturnReducer } from './selectSeatReturn';
import { reducer as setServiceListOnwardReducer } from './setServiceListOnward';
import { reducer as setServiceListReturnReducer } from './setServiceListReturn';
import { reducer as setServiceStateReducer } from './setServiceState';
import { reducer as openCloseNewSearchReducer } from './openCloseNewSearch';
import { reducer as showNewSearchReducer } from './showNewSearch';
import { reducer as getTrainListReducer } from './getTrainList';
import { reducer as setTrainListOnwardReducer } from './setTrainListOnward';
import { reducer as setInstantDiscountReducer } from './setInstantDiscount';

const reducers = [
  setSelectedServiceReducer,
  getServiceListReducer,
  getSelectedServiceReducer,
  setServiceOnwardReducer,
  setServiceReturnReducer,
  setServiceListReducer,
  selectSeatOnwardReducer,
  selectSeatReturnReducer,
  setServiceListOnwardReducer,
  setServiceListReturnReducer,
  setServiceStateReducer,
  openCloseNewSearchReducer,
  showNewSearchReducer,
  getTrainListReducer,
  setTrainListOnwardReducer,
  setInstantDiscountReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    // Handle cross-topic actions here
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}



// WEBPACK FOOTER //
// ./src/features/Pasajebus/PasajebusServiceList/redux/reducer.js